export const AddressOption = {
    types: ["address"],
    componentRestrictions: { country: "nz" }
};
